var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4894 13.5896C10.4894 13.3643 10.7054 13.1815 10.9801 13.1815H15.8728C16.1438 13.1815 16.3635 13.3641 16.3635 13.5896V16.4553C16.3635 16.6807 16.1475 16.8634 15.8728 16.8634H10.9801C10.7091 16.8634 10.4894 16.6808 10.4894 16.4553V13.5896ZM10.4894 4.99759C10.4894 4.77284 10.7054 4.59064 10.9801 4.59064H15.8728C16.1438 4.59064 16.3635 4.77511 16.3635 4.99759V11.9564C16.3635 12.1812 16.1475 12.3634 15.8728 12.3634H10.9801C10.7091 12.3634 10.4894 12.1789 10.4894 11.9564V4.99759ZM3.63623 9.49759C3.63623 9.27284 3.85226 9.09064 4.12695 9.09064H9.01963C9.29065 9.09064 9.51036 9.27511 9.51036 9.49759V16.4564C9.51036 16.6812 9.29433 16.8634 9.01963 16.8634H4.12695C3.85593 16.8634 3.63623 16.6789 3.63623 16.4564V9.49759ZM3.63623 4.99872C3.63623 4.77334 3.85226 4.59064 4.12695 4.59064H9.01963C9.29065 4.59064 9.51036 4.77322 9.51036 4.99872V7.86437C9.51036 8.08975 9.29433 8.27246 9.01963 8.27246H4.12695C3.85593 8.27246 3.63623 8.08987 3.63623 7.86437V4.99872Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard1);
export default __webpack_public_path__ + "static/media/dashboard1.9e76d4a36ae18b8af9f498f8fb4a5d4f.svg";
export { ForwardRef as ReactComponent };